import React, {Fragment} from "react";
import styles from "./LegalAttributes.module.scss";
import {IAttribute} from "@connox/typescript-library/types/items/interface/Item.interface";
import {useTranslation} from "react-i18next";

const LegalAttributes: React.FC<{attributes: IAttribute[]}> = ({attributes}) => {
  const {t} = useTranslation("customerAccount");
  const legalAttributesArray = attributes.filter((attr) =>
    [100028, 100087, 100105, 100112, 100053, 100091, 100093, 100179].includes(attr.itemAttributeId),
  );

  return (
    <div className={styles.wrapper}>
      {legalAttributesArray.map((attr) => {
        return (
          <div key={attr.itemAttributeId}>
            {
              // Attribut-Spezialfall: Kinderartikel-Warnhinweise
              attr.itemAttributeId === 100028 && (
                <strong className={styles.attrWrapper}>
                  <span className={styles.noUnderThreeYearsIcon} />
                  <span className={styles.label}>{attr.label}</span>
                </strong>
              )
            }
            {
              // Attribut-Spezialfall: Kinderartikel-Warnhinweise
              attr.itemAttributeId === 100087 && (
                <strong>
                  <span>{attr.value}</span>
                </strong>
              )
            }
            {
              // Attribut-Spezialfall: Leuchten-Hinweis "Nur zur Dekoration"
              attr.itemAttributeId === 100105 && (
                <div className={styles.attrWrapper}>
                  <span className={styles.decoLampIcon} />
                  <span className={styles.label}>{attr.label}</span>
                </div>
              )
            }
            {
              //  Ggf. Hinweis auf nicht austauschbare Leuchtmittel
              attr.itemAttributeId === 100112 && (
                <Fragment>
                  <span>{attr.value}</span>
                </Fragment>
              )
            }
            {
              // Ggf. Entsorgungshinweis
              [100053, 100091, 100093, 100179].includes(attr.itemAttributeId) && (
                <Fragment>
                  <span>{t("Bitte beachten Sie")}</span>{" "}
                  <a href={t("/kundenservice/versand.html#entsorgung")} target="_blank" rel="noreferrer">
                    {t("Informationen zur Entsorgung")}
                  </a>
                </Fragment>
              )
            }
          </div>
        );
      })}
    </div>
  );
};

export default LegalAttributes;
